import { Result } from "antd";
import AddWishButton from "@/views/Components/AddWishButton";

export function Empty({ isMyWishlist }: { isMyWishlist: boolean }) {
  if (!isMyWishlist) {
    return (
      <div className="flex h-full flex-col">
        <div className="grow place-content-center">
          <Result
            icon={<div className="text-5xl">😇</div>}
            title="This wishlist is empty"
            subTitle="Ask your friend to add something"
            className="items-center justify-center self-center"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="absolute left-0 flex h-screen w-full flex-col items-center justify-center gap-4">
      <div className="md:leading-16 text-h1 leading-[140%] md:text-display-large">
        🎊
      </div>
      <div className="md:leading-16 text-h6 font-semibold leading-[140%] md:text-display-large md:font-normal">
        Welcome to Wishlist!
      </div>
      <div className="text-base leading-[140%] md:text-headline-large md:font-semibold md:leading-10">
        Start adding your wishes to see them here
      </div>
      <div className="Label__Large text-center">
        <p> It looks like you haven&apos;t added any wishes yet. </p>
        <p>
          Click the &apos;Add wish&apos; button to start adding your first wish.
        </p>
        <p>Happy wishing!</p>
      </div>
      <AddWishButton />
    </div>
  );
}
